"use client"

import { LampDesk } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LampDeskIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LampDeskIcon = component(Icon)({ as: LampDesk })
